import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { PersonaScanStats } from './components/PersonaScanStats';
import { FilterOptions, FormData } from "./context/Form";

// use this way to expose the function as a global, otherwise webpack will replace the name with a shorter version
const container: HTMLElement | null = document.getElementById('ps-stats');

// tslint:disable-next-line no-null-keyword
if (container !== null) {

    const formdata: FormData = JSON.parse(
        container.getAttribute('data-formdata') as string,
    );

    const filteroptions: FilterOptions = JSON.parse(
        container.getAttribute('data-filteroptions') as string,
    );

    const ajaxUrl: string = container.getAttribute('data-ajaxUrl') as string;
    const nonce: string = container.getAttribute('data-nonce') as string;

    const scanId: string = container.getAttribute('data-scanId') as string;

    ReactDOM.render(
        <PersonaScanStats formdata={formdata} filteroptions={filteroptions} ajaxUrl={ajaxUrl} nonce={nonce} scanId={scanId} />,
        container,
    );
}

